import { PhoneScreenshotFrame } from './LandingScreenshotFrames'

const jobs = [
  {
    eyebrow: 'Job one',
    name: 'Fill every role - without chasing anyone',
    paragraphs: [
      'Members claim open speeches and roles themselves and hand them off member-to-member when plans change. Set your meeting cadence once, and every future meeting appears on the schedule ready to fill',
      'Whatever is still open, one click of auto-assign finishes - with fair rotation, so nobody gets Timer four weeks in a row. Self-signup alone still needs a nagging VPE - auto-assign is what makes the schedule actually complete itself',
    ],
    outcome: 'You stop being the bottleneck',
    imageLayout: 'photo',
    image: '/fill-every-role.png',
    alt: 'Member choosing their meeting role on their phone',
  },
  {
    eyebrow: 'Job two',
    name: 'Keep everyone informed - without the noise',
    paragraphs: [
      'The agenda is one live link that is always current. When someone drops out, the swap resolves itself and everyone looking at the schedule sees the change instantly - nothing to regenerate, nothing to re-send',
      'Members get one configurable digest they will actually read. No ping for every open role - by design. Your members’ notifications stay quiet, so ours get read',
    ],
    outcome: 'Dropouts stop being your emergency',
    imageLayout: 'photo',
    image: '/three-officer-jobs/job-2.png',
    alt: 'Digest email showing the upcoming meeting, open roles, and filled roles',
  },
  {
    eyebrow: 'Job three',
    name: 'Remember every speech - automatically',
    paragraphs: [
      'Every speech and role lands on each member’s profile, with achievements to match. Planning who does what next takes seconds, not archaeology',
      'Progress toward club recognition stays visible all year - no end-of-term scramble to reconstruct who did what',
    ],
    outcome: 'The club’s history keeps itself',
    imageLayout: 'photo',
    image: '/three-officer-jobs/job-3.png',
    alt: 'Member profile showing role history and speeches given',
  },
]

export default function LandingProductTour() {
  return (
    <div className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:text-center">
          <h2 className="text-base font-semibold leading-7 text-indigo-600">
            The three officer jobs
          </h2>
          <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Everything the weekly meeting needs - and the club does most of it
          </p>
        </div>
        <div className="mx-auto mt-16 flex max-w-2xl flex-col gap-y-20 sm:mt-20 lg:mt-24 lg:max-w-none">
          {jobs.map((job, index) => (
            <div
              key={job.name}
              className="grid grid-cols-1 items-center gap-x-16 gap-y-8 lg:grid-cols-2">
              <div className={index % 2 === 1 ? 'lg:order-last' : undefined}>
                <p className="text-sm font-semibold uppercase tracking-wide text-indigo-600">
                  {job.eyebrow}
                </p>
                <h3 className="mt-2 text-2xl font-bold tracking-tight text-gray-900">
                  {job.name}
                </h3>
                {job.paragraphs.map((paragraph) => (
                  <p
                    key={paragraph}
                    className="mt-4 text-base leading-7 text-gray-600">
                    {paragraph}
                  </p>
                ))}
                <p className="mt-4 text-base font-semibold leading-7 text-gray-900">
                  {job.outcome}
                </p>
              </div>
              <div
                className={`flex min-h-[27rem] items-center justify-center overflow-hidden rounded-2xl ${
                  job.imageLayout === 'photo'
                    ? ''
                    : 'bg-gradient-to-br from-gray-900 to-indigo-950 p-6'
                }`}>
                {job.imageLayout === 'photo' ? (
                  <img
                    src={job.image}
                    alt={job.alt}
                    className="h-full w-full rounded-2xl object-cover"
                  />
                ) : job.imageLayout === 'wide' ? (
                  <img
                    src={job.image}
                    alt={job.alt}
                    className="w-full max-w-2xl rounded-xl object-contain shadow-2xl shadow-indigo-950/40"
                  />
                ) : (
                  <PhoneScreenshotFrame
                    src={job.image}
                    alt={job.alt}
                    className="max-w-[13.5rem]"
                    imageClassName="object-cover object-top"
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
